<!--page starts-->
<section class="page-wrapper">
    <div class="confirmation-section cf"> 
        <div class="container">
            <div class="confirmation-detail cf">
                <div class="titel-box">
					<h2 class="titel-name">notfound</h2>
				</div>
            </div>
        </div>
    </div>
    <div class="confirmation-success-section" style="background-image: url(assets/images/logiin-bg-img.png);">
        <div class="container">
            <div class="confirmation-success-detail">
                <div class="confirmation-success-detail-inner">
                    <h2>404</h2>
                    <p>Sorry, we can’t find the page you were looking for !!</p>
                    <div class="confirmation-success-btn">
                        <a routerLink="/">Go to Home</a>
                    </div>
                </div>

            </div>
        </div>
        <div class="confirmation-success-overlay"></div>
    </div>
 </section><!-- page ends-->